var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22046_4082)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41772 8.00002C1.41772 4.36472 4.36471 1.41773 8 1.41773C11.6353 1.41773 14.5823 4.36472 14.5823 8.00002C14.5823 11.6353 11.6353 14.5823 8 14.5823C4.36471 14.5823 1.41772 11.6353 1.41772 8.00002ZM8 0C3.58172 0 0 3.58173 0 8.00002C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8.00002C16 3.58173 12.4183 0 8 0ZM5.54854 4.05332C5.68142 3.97917 5.84407 3.98258 5.97371 4.06225L11.8 7.64268C11.9243 7.71904 12 7.85431 12 8.00002C12 8.14572 11.9243 8.28099 11.8 8.35736L5.97371 11.9378C5.84407 12.0175 5.68142 12.0209 5.54854 11.9467C5.41566 11.8726 5.33333 11.7325 5.33333 11.5804V4.41959C5.33333 4.26758 5.41566 4.12746 5.54854 4.05332Z",
    fill: "#CCCFD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22046_4082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.ab3a6c6bbc718d1f5963ad2e6b8b07f2.svg";
export { ForwardRef as ReactComponent };